import { createAssetLibraryFetsClient } from './asset-library-fets-client';
import { createGetAssetLibraryAccess } from './asset-library-requests/getAssetLibraryAccess';
import { createGetAssetDirectoryTree } from './asset-library-requests/getAssetDirectoryTree';
import { createCreateAssetFolder } from './asset-library-requests/createAssetFolder';
import { createRenameAssetFolder } from './asset-library-requests/renameAssetFolder';
import { createMoveAssetFolder } from './asset-library-requests/moveAssetFolder';
import { createArchiveAssetDirectory } from './asset-library-requests/archiveAssetDirectory';
import { createQueryAssets } from './asset-library-requests/queryAssets';
import { createGetAssetDetail } from './asset-library-requests/getAssetDetail';
import { createUploadAsset } from './asset-library-requests/uploadAsset';
import { createReplaceAssetFile } from './asset-library-requests/replaceAssetFile';
import { createRenameAsset } from './asset-library-requests/renameAsset';
import { createCopyAssets } from './asset-library-requests/copyAssets';
import { createMoveAssets } from './asset-library-requests/moveAssets';
import { createArchiveAsset } from './asset-library-requests/archiveAsset';
import { createArchiveAssets } from './asset-library-requests/archiveAssets';

const _createClient = (backendUrl: string, provideFunc: () => Promise<string>) => {
  const apiClient = createAssetLibraryFetsClient(backendUrl, provideFunc);

  return {
    getAssetLibraryAccess: createGetAssetLibraryAccess(apiClient),

    // Folders
    getAssetDirectoryTree: createGetAssetDirectoryTree(apiClient),
    createAssetFolder: createCreateAssetFolder(apiClient),
    renameAssetFolder: createRenameAssetFolder(apiClient),
    moveAssetFolder: createMoveAssetFolder(apiClient),
    archiveAssetDirectory: createArchiveAssetDirectory(apiClient),

    // Assets
    queryAssets: createQueryAssets(apiClient),
    getAssetDetail: createGetAssetDetail(apiClient),
    uploadAsset: createUploadAsset(apiClient),
    replaceAssetFile: createReplaceAssetFile(apiClient),
    renameAsset: createRenameAsset(apiClient),
    copyAssets: createCopyAssets(apiClient),
    moveAssets: createMoveAssets(apiClient),
    archiveAsset: createArchiveAsset(apiClient),
    archiveAssets: createArchiveAssets(apiClient),
  } as const;
};

export type AssetLibraryApiClient = ReturnType<typeof _createClient>;
export const createAssetLibraryApiClient = (
  backendUrl: string,
  provideFunc: () => Promise<string>
): AssetLibraryApiClient => _createClient(backendUrl, provideFunc);
